(function (root, factory) {
    var api = factory();
    if (typeof module === 'object' && module.exports) module.exports = api;
    else root.SharkSpecFacts = api;
})(typeof self !== 'undefined' ? self : this, function () {
    var N_ = function (s) { return s; };
    var L = {
        playingGeometry: N_('Playing Geometry'), materialsAndFinish: N_('Materials & Finish'),
        fretCount: N_('Frets'), scaleLength: N_('Scale Length'), profile: N_('Profile'),
        neckShape: N_('Neck Shape'), shapeAt1And12: N_('Shape @1 / @12'),
        neckThickness: N_('Neck Thickness'), thicknessAt1And12: N_('Thickness @1 / @12'),
        fretboardRadius: N_('Fretboard Radius'), radiusAt1And12: N_('Radius @1 / @12'), compoundTag: N_('Compound'),
        nutWidth: N_('Nut Width'), neckWood: N_('Neck Wood'), fretboardWood: N_('Fretboard Wood'), headstockWood: N_('Headstock Face'),
        matchedToNeck: N_('Matched to neck'), natural: N_('Natural'), stained: N_('Stained'), solidColour: N_('Solid Colour'),
        bodyWood: N_('Body Wood'), topWood: N_('Top Wood'),
        binding: N_('Binding'), sideDots: N_('Side Dots'), inlayDesign: N_('Inlay Design'), logoMaterial: N_('Logo Material'),
        humbuckerCoverColors: N_('Humbucker Cover Colours'), neckPickupCover: N_('Neck Pickup Cover'), bridgePickupCover: N_('Bridge Pickup Cover'),
        pickupFrames: N_('Pickup Frames'), knobsSwitches: N_('Knobs, Switches & Buttons'), controlKnobs: N_('Control Knobs'), switches: N_('Switches'), buttons: N_('Buttons'),
        bridgeBasePlate: N_('Base Plate'), saddleBlock: N_('Saddle Block'), rollers: N_('Rollers'), tunersArmCaps: N_('Tuners & Arm Caps'), tremoloArm: N_('Tremolo Arm'),
        sharkNut: N_('Shark Nut'), sharkNutBasePlate: N_('Base Plate'), stringCarrier: N_('String Carrier'),
        customScallopDepth: N_('Custom Scallop Depth'), scallop: N_('Scallop'), depth: N_('Depth'), progression: N_('Progression'),
        series: N_('Series'), collection: N_('Collection'), body: N_('Body'), pickups: N_('Pickups'), fxCard: N_('FX Card'),
        profileChangedMessage: N_('Selected template geometry')
    };
    var EARS = {
        neck: { title: N_('Neck & Headstock'), description: N_('Profile, geometry, fretboard, neck wood and finish, and headstock specification.') },
        body: { title: N_('Body'), description: N_('Body shape, woods, finish, colour, contour and fret-count routing.') },
        electronics: { title: N_('Electronics'), description: N_('Electronics module, installed bridge and neck pickups, and, on Supreme builds, two Main plus one Mini FX Card.') },
        hardware: { title: N_('Hardware & Cosmetics'), subtitle: N_('Anodization & More'), description: N_('Bindings, inlays, logo and side dots; pickup and control finishes; bridge and nut anodization.') }
    };
    var PICKUP_CATS = { neck: 16, bridge: 17 };
    var FX_SLOTS = [{ id: 'mini', categoryId: 20, label: N_('MINI FX') }, { id: 'main1', categoryId: 21, label: N_('FX 1') }, { id: 'main2', categoryId: 24, label: N_('FX 2') }];
    var PRIME_FX_NOTE = N_('Prime Electronics uses its own direct signal architecture and does not host FX Cards.');

    function esc(value) {
        return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    function normKey(value) { return String(value || '').toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim(); }

    function partBy(data, categoryId) {
        return (data.properties || []).find(function (part) { return Number(part.category_id) === categoryId; }) || null;
    }

    function propRows(part, key) {
        var wanted = normKey(key);
        return ((part && part.property) || []).filter(function (row) { return normKey(row.property_name) === wanted; });
    }

    function prop(part, key) {
        var rows = propRows(part, key);
        if (!rows.length) return '';
        var valued = rows.find(function (row) {
            var value = String(row.design_part_property_value || '').trim();
            return value && !/^(YES|NO)$/i.test(value);
        });
        return String((valued || rows[0]).design_part_property_value || '').trim();
    }

    function mmNum(value) {
        var match = String(value || '').match(/([\d.]+)\s*mm/i);
        return match ? match[1] : String(value || '').replace(/["]/g, '');
    }
    function inNum(value) {
        var match = String(value || '').match(/([\d.]+)\s*"/);
        return match ? match[1] : String(value || '');
    }
    function dimensionPair(value) {
        return String(value || '—').replace(/mm\./gi, 'mm').replace(/"/g, '″').replace(/\s*\/\s*/g, ' / ').trim();
    }
    function shapeLetter(value) {
        var match = String(value || '').match(/^([A-Z])/i);
        return match ? match[1].toUpperCase() : String(value || '');
    }
    function endpointPresentation(first, last, formatter, unit) {
        var a = first != null && String(first).trim() ? String(formatter(first)).trim() : '';
        var b = last != null && String(last).trim() ? String(formatter(last)).trim() : '';
        var paired = !!(a && b && a !== b);
        var display = paired ? a + ' / ' + b : (a || b);
        return { paired: paired, value: display ? display + (unit || '') : '—' };
    }
    function arrowPair(first, second) {
        var a = String(first == null ? '' : first).trim();
        var b = String(second == null ? '' : second).trim();
        if (!a && !b) return '';
        if (a === b) return a;
        return (a || '—') + ' → ' + (b || '—');
    }
    function capWord(value) {
        var text = String(value || '');
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    function extract(data) {
        var neck = partBy(data, 11);
        var body = partBy(data, 10);
        var bridge = partBy(data, 12);
        var nut = partBy(data, 18);
        var electronics = (data.properties || []).find(function (part) { return /electronics_module/.test(String(part.model_type || '')); });
        var neckPickup = partBy(data, PICKUP_CATS.neck);
        var bridgePickup = partBy(data, PICKUP_CATS.bridge);
        var fxParts = [20, 21, 24].map(function (cat) { return partBy(data, cat); }).filter(Boolean);
        var headTopValue = prop(neck, 'HEADSTOCK TOP WOOD');
        var neckRows = (neck && neck.property) || [];
        function chainChild(parentRow) {
            return parentRow ? neckRows.find(function (row) { return Number(row.property_parent_id) === Number(parentRow.property_id); }) : null;
        }
        var scallopRow = neckRows.find(function (row) { return normKey(row.property_name) === 'SCALLOP'; });
        var scallopDetailRow = chainChild(scallopRow);
        var scallopModeRaw = scallopRow ? String(scallopRow.design_part_property_value || '').trim() : '';
        var scallopDetail = scallopDetailRow ? String(scallopDetailRow.design_part_property_value || '').trim() : '';
        var scallopMode = '';
        if (/MANUAL/i.test(scallopModeRaw)) scallopMode = ['Manual', scallopDetail].filter(Boolean).join(' · ');
        else if (/TEMPLATE/i.test(scallopModeRaw) && scallopDetail && !/^(NONE|NO)$/i.test(scallopDetail)) scallopMode = ['Template', scallopDetail].join(' · ');
        else if (scallopModeRaw && !/^(NONE|NO|TEMPLATE|MANUAL)$/i.test(scallopModeRaw)) scallopMode = scallopModeRaw;
        var templateRow = neckRows.find(function (row) { return normKey(row.property_name) === 'TEMPLATE' && Number(row.property_parent_id) === 1394; });
        return {
            neck: {
                part: neck,
                headstock: prop(neck, 'HEADSTOCK TYPE'),
                scale: prop(neck, 'SCALE LENGTH'),
                fret: prop(neck, 'FRET'),
                thickness0: prop(neck, 'Thickness at 0 Fret'),
                thickness12: prop(neck, 'Thickness at 12th Fret'),
                nutWidth: prop(neck, 'NECK WIDTH AT 0 FRET'),
                shape0: prop(neck, 'Symmetric Shape at 0 Fret'),
                shape12: prop(neck, 'Symmetric Shape at 12th Fret'),
                radius0: prop(neck, 'FRETBOARD RADIUS AT 0 FRET'),
                radiusLast: prop(neck, 'FRETBOARD RADIUS AT LAST FRET'),
                finish: prop(neck, 'NECK FINISH'),
                finishType: prop(neck, 'NECK FINISH TYPE'),
                wood: prop(neck, 'NECK WOOD'),
                stain: prop(neck, 'NECK STAIN'),
                fretboardWood: prop(neck, 'FRETBOARD WOOD'),
                fretboardStain: prop(neck, 'FRETBOARD STAIN'),
                headTopWood: /^(YES|NO)$/i.test(headTopValue) ? '' : headTopValue,
                headTopStain: prop(neck, 'HEADSTOCK TOP WOOD STAIN'),
                binding: prop(neck, 'BINDING'),
                sideDots: prop(neck, 'SIDE DOTS COLOR'),
                inlayDesign: prop(neck, 'INLAY DESIGN'),
                inlayMaterial: prop(neck, 'INLAY MATERIAL'),
                logo: prop(neck, 'SHARK LOGO MATERIAL'),
                scallop: scallopMode,
                scallopTop: /Manual/i.test(scallopMode) ? prop(neck, 'Top Depth') : '',
                scallopBottom: /Manual/i.test(scallopMode) ? prop(neck, 'Bottom Depth') : '',
                templateName: templateRow ? String(templateRow.design_part_property_value || '').trim() : '',
                geometry: (function () {
                    var shapeMode = prop(neck, 'NECK SHAPE');
                    var customKind = /CUSTOM/i.test(shapeMode) ? prop(neck, 'CUSTOM') : '';
                    var variant = customKind ? prop(neck, customKind) : '';
                    var patterns = [/Shape at/i, /Curve at/i, /Flatness at/i];
                    var rows = ((neck && neck.property) || []).filter(function (row) {
                        return patterns.some(function (pattern) { return pattern.test(row.property_name); });
                    }).map(function (row) {
                        return { key: String(row.property_name).trim(), value: String(row.design_part_property_value || '').trim() };
                    });
                    return { isCustom: /CUSTOM/i.test(shapeMode), kind: customKind, variant: variant, rows: rows };
                })()
            },
            body: {
                part: body,
                name: body ? body.part_name : '',
                wood: prop(body, 'BODY WOOD'),
                topWood: (function () {
                    var value = prop(body, 'TOP WOOD');
                    return /^(YES|NO)$/i.test(value) ? '' : value;
                })(),
                topStain: prop(body, 'TOP WOOD STAIN COLOR') || prop(body, 'TOP WOOD STAIN'),
                backStain: prop(body, 'BACK WOOD STAIN COLOR') || prop(body, 'STAIN COLOR') || prop(body, 'BODY STAIN') || prop(body, 'BACK STAIN'),
                solid: prop(body, 'SOLID COLOR'),
                finish: prop(body, 'BODY FINISH'),
                contour: prop(body, 'CONTOUR COLOR'),
                frame: prop(body, 'PICKUP FRAME COLOR'),
                fretRoute: prop(body, 'FRET COUNT - BODY')
            },
            bridge: bridge ? {
                main: prop(bridge, 'BRIDGE MAIN COLOR'),
                secondary: prop(bridge, 'BRIDGE SECONDARY COLOR'),
                rollers: prop(bridge, 'ROLLER COLOR'),
                knobsArmCap: prop(bridge, 'TUNING KNOBS AND ARM CAP COLOR'),
                arm: prop(bridge, 'TREMOLO ARM COLOR')
            } : null,
            nut: nut ? { main: prop(nut, 'NUT MAIN COLOR'), secondary: prop(nut, 'NUT SECONDARY COLOR') } : null,
            electronics: {
                part: electronics || null,
                name: electronics ? electronics.part_name : '',
                isSupreme: !!electronics && String(electronics.model_type) === 'electronics_module',
                knobs: prop(electronics, 'KNOBS COLOR'),
                switches: prop(electronics, 'SWITCHES COLOR'),
                buttons: prop(electronics, 'BUTTONS COLOR')
            },
            covers: {
                neck: neckPickup ? (prop(neckPickup, 'HUMBUCKER COVER COLOR') || prop(neckPickup, 'PLASTIC COVER COLOR')) : '',
                bridge: bridgePickup ? (prop(bridgePickup, 'HUMBUCKER COVER COLOR') || prop(bridgePickup, 'PLASTIC COVER COLOR')) : ''
            },
            fxParts: fxParts
        };
    }

    var publicWoodNames = { 'maple': N_('Hard Maple'), 'african ebony': N_('Ebony'), 'macassar ebony': N_('Exotic Ebony'), 'madagascar rosewood': N_('Rosewood'), 'indian rosewood': N_('Rosewood'), 'zebra wood': N_('Zebrano') };
    function customerWoodName(value) {
        var parts = String(value || '').split(/\s*(?:·|\s-\s)\s*/).filter(function (part) {
            return part && !/^(?:bookmatched|symmetric|master(?:\s+grade)?|aaa(?:\s+grade)?|\d+\s*[- ]?pieces?(?:\s+(?:bookmatched|symmetric))?)$/i.test(part.trim());
        });
        var clean = parts.join(' ').replace(/\s+/g, ' ').trim();
        return publicWoodNames[clean.toLowerCase()] || clean;
    }
    function isNaturalFinishValue(value) { return !value || /^(?:none|natural|no stain|clear)$/i.test(String(value).trim()); }
    function visibleFinish(value) { return !isNaturalFinishValue(value); }
    function finishPresentation(sheen, finishType, colourValue, forceStained) {
        var isSolid = !forceStained && /solid/i.test(String(finishType || ''));
        var isNatural = !isSolid && isNaturalFinishValue(colourValue);
        var mode = isSolid ? N_('Solid') : L.stained;
        var colour = isNatural ? L.natural : (colourValue || L.natural);
        return { treatment: isNatural ? N_('No stain') : mode, sheen: sheen || N_('Satin'), colour: colour, kind: isNatural ? 'natural' : isSolid ? 'solid color' : 'stain' };
    }
    function bodyPresentation(x) {
        var hasTopWood = !!x.body.topWood;
        var bodyIsSolid = !hasTopWood && !!x.body.solid;
        var backColour = bodyIsSolid ? x.body.solid : (visibleFinish(x.body.backStain) ? x.body.backStain : N_('Natural'));
        var back = { treatment: bodyIsSolid ? N_('Solid') : (isNaturalFinishValue(backColour) ? N_('No stain') : L.stained), sheen: x.body.finish || N_('Satin'), colour: backColour || L.natural, kind: bodyIsSolid ? 'solid color' : (isNaturalFinishValue(backColour) ? 'natural' : 'stain') };
        var topColour = hasTopWood ? (visibleFinish(x.body.topStain) ? x.body.topStain : N_('Natural')) : '';
        var top = { treatment: isNaturalFinishValue(topColour) ? N_('No stain') : L.stained, sheen: x.body.finish || N_('Satin'), colour: topColour || L.natural, kind: isNaturalFinishValue(topColour) ? 'natural' : 'stain' };
        return { hasTopWood: hasTopWood, bodyIsSolid: bodyIsSolid, back: back, top: top };
    }
    function bodyIdentity(meta, x) {
        var identityBody = ((meta.identity || {}).body || {});
        var key = String(x.body.name || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
        return { key: key, record: (identityBody.cases || {})[key] || { canonicalName: x.body.name, description: '' } };
    }
    function normalizeBinding(value) {
        if (!value) return { type: 'none', material: N_('No Binding') };
        var text = String(value).trim();
        var wood = text.match(/^wood\s*(?:·|:|-)?\s*(.+)$/i);
        if (/^no binding$/i.test(text)) return { type: 'none', material: text };
        if (wood && wood[1]) return { type: 'wood', material: wood[1].trim() };
        return { type: 'epoxy', material: text };
    }
    function pickupCoverFinish(meta, value, fallbackHex) {
        var registry = (meta.material_options || {}).pickupCovers || null;
        var lookup = (registry && registry.byName) || {};
        var clean = String(value || '').trim();
        var alias = registry && registry.aliases && registry.aliases[clean.toLowerCase()];
        return lookup[(alias || clean).toLowerCase()] || { name: clean, hex: fallbackHex, code: N_('UNREGISTERED'), status: 'unregistered', material: 'painted-cover', description: N_('Unregistered cover value; using a neutral compatibility preview.') };
    }

    function pickupOutputDisplay(value) { return /^low$/i.test(String(value || '')) ? N_('Vintage') : value; }
    function pickupSpecValues(record) {
        var magnetLabel = record ? String(record.magnet || '').toUpperCase().replace(/\s+([A-Z0-9]+)$/, ' - $1') : '';
        var electricalLabel = record && record.dcrKohm != null ? N_('DC Resistance') : N_('Architecture');
        var electricalValue = record ? (record.dcrKohm != null ? record.dcrKohm + ' kΩ' : (record.architecture || '')) : '';
        var peakValue = record && Number.isFinite(Number(record.resonantPeakHz)) ? (Number(record.resonantPeakHz) / 1000).toFixed(2) + ' kHz' : '—';
        var voicing = (record && (record.voicing || record.description)) || '';
        var recommendedFor = (record && (record.recommendedFor || record.description)) || '';
        return { magnetLabel: magnetLabel, electricalLabel: electricalLabel, electricalValue: electricalValue, peakValue: peakValue, voicing: voicing, recommendedFor: recommendedFor };
    }
    function pickupComponentRecord(meta, modelName, position) {
        var suffix = position === 'Neck' ? '-N' : '-B';
        var key = String(modelName || '').trim().split(/\s+/)[0].toUpperCase() + suffix;
        return { key: key, record: (meta.pickup_component || {})[key] || null };
    }
    function fxCodeOf(meta, modelName) {
        var match = String(modelName || '').toUpperCase().match(/\b([A-Z]{2,4}-\d)\b/);
        var code = match ? match[1] : '';
        var aliases = (meta.alias && meta.alias.all && meta.alias.all.fxCodes) || {};
        return aliases[code] || code;
    }
    function fxCardInfo(meta, modelName) {
        var code = fxCodeOf(meta, modelName) || '—';
        var card = (meta.fx_card || {})[code];
        var name = (card && String(card.canonicalName).replace(code, '').trim()) || String(modelName).replace(/\b[A-Z]{2,4}-\d\b/i, '').trim();
        return { code: code, name: name, description: (card && card.description) || '' };
    }
    function fxPackHeading(packName) { return packName ? String(packName).replace(/\s*FX Pack$/i, '') : N_('Custom'); }
    function fxPackStory(packs, packName) {
        var packRow = (packs || []).find(function (pack) { return pack.pack_name === packName; });
        return (packRow && packRow.pack_description) || N_('A custom three-module Supreme FX chain.');
    }
    function architectureName(x) {
        var name = x.electronics.name || (x.electronics.isSupreme ? N_('Supreme Electronics') : N_('Prime Electronics'));
        if (!/electronics/i.test(name)) name += ' Electronics';
        return name;
    }

    function nameNorm(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
    function profileMetaFor(meta, name) {
        var profiles = meta.neck_profile || {};
        if (profiles[name]) return profiles[name];
        var aliases = (meta.alias && meta.alias.all && meta.alias.all.profiles) || {};
        var candidates = [aliases[name], name + ' (Reverse Taper)', String(name).replace(' (Asym)', ' (Asymmetric)')];
        for (var i = 0; i < candidates.length; i++) {
            if (candidates[i] && profiles[candidates[i]]) return profiles[candidates[i]];
        }
        var wanted = nameNorm(name);
        var keys = Object.keys(profiles);
        for (var k = 0; k < keys.length; k++) {
            if (nameNorm(keys[k]) === wanted || nameNorm(keys[k]) === wanted + 'reversetaper') return profiles[keys[k]];
        }
        return null;
    }

    function fretsDisplay(x, fretsOption) {
        return fretsOption ? String(fretsOption.label).replace(/\s*\(([^)]+)\)/, ' · $1') : (x.neck.fret ? x.neck.fret : '');
    }
    function scaleDisplay(x, scaleOption) {
        return scaleOption ? (/24\.75/.test(scaleOption.label) ? N_('Short · 24.75″') : N_('Long · 25.5″')) : (/24\.75/.test(x.neck.scale) ? N_('Short · 24.75″') : N_('Long · 25.5″'));
    }
    function neckGeometry(meta, x, profileOption, profileChanged) {
        var profileDisplay = profileOption ? profileOption.label : (!x.neck.geometry.isCustom && x.neck.templateName) ? x.neck.templateName : ((x.neck.shape0 || x.neck.shape12) ? 'Custom · ' + shapeLetter(x.neck.shape0) + (x.neck.shape12 && shapeLetter(x.neck.shape12) !== shapeLetter(x.neck.shape0) ? ' / ' + shapeLetter(x.neck.shape12) : '') + ' Profile' : N_('Custom Profile'));
        var activeTemplateRecord = !x.neck.geometry.isCustom ? profileMetaFor(meta, profileOption ? profileOption.label : x.neck.templateName) : null;
        var activeBackSpec = activeTemplateRecord && activeTemplateRecord.backSpec;
        var templateOwned = activeTemplateRecord && activeTemplateRecord.profileOwned;
        var shape0 = shapeLetter(x.neck.shape0) || (templateOwned && templateOwned.shape0) || '';
        var shape12 = shapeLetter(x.neck.shape12) || (templateOwned && templateOwned.shape12) || '';
        if (!x.neck.geometry.isCustom && templateOwned) {
            shape0 = templateOwned.shape0 || shape0;
            shape12 = templateOwned.shape12 || shape12;
        }
        var shapePaired = !!(shape0 && shape12 && shape0 !== shape12);
        var shapeSummary = (shapePaired ? shape0 + ' / ' + shape12 : (shape0 || shape12)) + (x.neck.scallop ? ' · ' + N_('Scalloped') : '');
        var thicknessSource0 = x.neck.thickness0;
        var thicknessSource12 = x.neck.thickness12;
        if (activeBackSpec && (!thicknessSource0 || profileChanged)) {
            thicknessSource0 = activeBackSpec.thickness0 + ' mm';
            thicknessSource12 = activeBackSpec.thickness12 + ' mm';
        }
        return {
            profileDisplay: profileDisplay,
            shapePaired: shapePaired,
            shapeSummary: shapeSummary,
            thickness: endpointPresentation(thicknessSource0, thicknessSource12, mmNum, ' mm'),
            radius: endpointPresentation(x.neck.radius0, x.neck.radiusLast, function (value) { return inNum(value).replace(/″/g, ''); }, '″')
        };
    }

    // The one rule for "which pack matches these slots", shared with item-quick-config.js
    // matchingPack. itemsFor(packId) and swapsFor(categoryId) return arrays.
    function matchPack(packs, itemsFor, swapsFor, slots) {
        for (var i = 0; i < packs.length; i++) {
            var items = itemsFor(packs[i].pack_id);
            var allMatch = slots.every(function (slot) {
                var item = items.find(function (candidate) { return Number(candidate.category_id) === slot.categoryId; });
                if (!item) return false;
                var swap = swapsFor(slot.categoryId).find(function (candidate) { return candidate.model_name === item.model_name || Number(candidate.model_id) === Number(item.model_id); });
                var modelId = item.model_id != null ? Number(item.model_id) : (swap ? Number(swap.model_id) : null);
                return modelId != null && modelId === Number(slot.modelId);
            });
            if (allMatch) return packs[i];
        }
        return null;
    }

    function matchPackName(packs, packItems, swaps, slots) {
        var pack = matchPack(packs,
            function (packId) { return packItems.filter(function (item) { return Number(item.pack_id) === Number(packId); }); },
            function (categoryId) { return swaps.filter(function (candidate) { return Number(candidate.category_id) === categoryId; }); },
            slots);
        return pack ? pack.pack_name : '';
    }

    function clean(value) { return String(value == null ? '' : value).replace(/\s+/g, ' ').trim(); }
    function joinDot(values) { return values.map(clean).filter(Boolean).join(' · '); }
    function section(id, title, rows) {
        var kept = rows.filter(function (row) { return row && clean(row.value) && clean(row.value) !== '—'; }).map(function (row) { return row.name ? { label: row.label, value: clean(row.value), name: true } : { label: row.label, value: clean(row.value) }; });
        return kept.length ? { id: id, title: title, rows: kept } : null;
    }
    function row(label, value) { return { label: label, value: value }; }
    function nameRow(label, value) { return { label: label, value: value, name: true }; }
    function materialValue(name, presentation) {
        return joinDot([name, presentation.treatment, presentation.colour, presentation.sheen]);
    }
    function weightDisplay(grams) {
        var g = Number(grams) || 0;
        return g > 0 ? (g / 1000).toFixed(2) + ' kg / ' + (g * 0.00220462).toFixed(2) + ' lbs' : '';
    }
    function pickupDetail(record, modelName) {
        var output = record ? record.outputClass : ((String(modelName || '').match(/\(([^)]+)\)/) || [])[1] || '');
        output = pickupOutputDisplay(String(output || '').replace(/\s*Output\s*/i, '').trim());
        if (!record) return output ? output + ' output' : '';
        var spec = pickupSpecValues(record);
        return joinDot([
            record.series ? String(record.series) + ' series' : '',
            output ? output + ' output' : '',
            spec.magnetLabel,
            spec.electricalValue,
            spec.peakValue !== '—' ? 'Resonant peak ' + spec.peakValue : ''
        ]);
    }
    function pickupCharacter(record) {
        if (!record) return '';
        var spec = pickupSpecValues(record);
        return clean([spec.voicing, spec.recommendedFor ? 'Recommended for: ' + spec.recommendedFor : ''].filter(Boolean).join(' '));
    }

    function specFacts(data, meta, kind) {
        meta = meta || {};
        var product = data.product || {};
        var x = extract(data);
        if (!x.neck.part && !x.body.part) return null;
        var sections = [];

        sections.push(section('build', N_('Build'), [
            row(L.series, x.electronics.part ? (x.electronics.isSupreme ? N_('Supreme') : N_('Prime')) : ''),
            nameRow(L.collection, product.collection),
            row(N_('Weight'), weightDisplay(product.product_weight))
        ]));

        if (x.neck.part) {
            var geo = neckGeometry(meta, x, null, false);
            var neckFinish = finishPresentation(x.neck.finish, x.neck.finishType, x.neck.stain, false);
            var fretboardFinish = finishPresentation(x.neck.finish, x.neck.finishType, x.neck.fretboardStain, true);
            var headFace = x.neck.headTopWood || L.matchedToNeck;
            var headFinish = finishPresentation(x.neck.finish, x.neck.finishType, x.neck.headTopWood ? x.neck.headTopStain : x.neck.stain, !!x.neck.headTopWood);
            sections.push(section('neck', EARS.neck.title, [
                row(L.fretCount, fretsDisplay(x, null)),
                row(L.scaleLength, x.neck.scale ? scaleDisplay(x, null) : ''),
                row(L.profile, geo.profileDisplay),
                row(geo.shapePaired ? L.shapeAt1And12 : L.neckShape, geo.shapeSummary),
                row(geo.thickness.paired ? L.thicknessAt1And12 : L.neckThickness, geo.thickness.value),
                row(geo.radius.paired ? L.radiusAt1And12 : L.fretboardRadius, geo.radius.paired ? geo.radius.value + ' (' + L.compoundTag + ')' : geo.radius.value),
                row(L.nutWidth, x.neck.nutWidth ? dimensionPair(x.neck.nutWidth) : ''),
                row(L.scallop, x.neck.scallop || N_('None')),
                row(N_('Scallop Depth'), (x.neck.scallopTop || x.neck.scallopBottom) ? joinDot([x.neck.scallopTop ? 'Top ' + dimensionPair(x.neck.scallopTop) : '', x.neck.scallopBottom ? 'Bottom ' + dimensionPair(x.neck.scallopBottom) : '']) : ''),
                row(L.neckWood, x.neck.wood ? materialValue(customerWoodName(x.neck.wood), neckFinish) : ''),
                row(L.fretboardWood, x.neck.fretboardWood ? materialValue(customerWoodName(x.neck.fretboardWood), fretboardFinish) : ''),
                row(L.headstockWood, materialValue(customerWoodName(headFace), headFinish)),
                nameRow(N_('Headstock'), String(x.neck.headstock || '').replace('(less)', ''))
            ]));
        }

        if (x.body.part) {
            var bp = bodyPresentation(x);
            var identity = bodyIdentity(meta, x).record;
            var contour = clean(x.body.contour);
            sections.push(section('body', EARS.body.title, [
                nameRow(N_('Body Shape'), identity.canonicalName || x.body.name),
                row(N_('Body Character'), identity.description),
                row(L.bodyWood, x.body.wood ? materialValue(customerWoodName(x.body.wood), bp.back) : ''),
                row(L.topWood, bp.hasTopWood ? materialValue(customerWoodName(x.body.topWood), bp.top) : ''),
                row(N_('Contour'), contour && !/^(no contour|none|natural)$/i.test(contour) ? contour : ''),
                row(N_('Fret-Count Routing'), x.body.fretRoute)
            ]));
        }

        var elecRows = [];
        if (x.electronics.part) elecRows.push(row(N_('Electronics'), architectureName(x)));
        [
            { categoryId: PICKUP_CATS.bridge, position: N_('Bridge'), pickup: N_('Bridge Pickup'), specs: N_('Bridge Pickup Specs'), voicing: N_('Bridge Pickup Voicing') },
            { categoryId: PICKUP_CATS.neck, position: N_('Neck'), pickup: N_('Neck Pickup'), specs: N_('Neck Pickup Specs'), voicing: N_('Neck Pickup Voicing') }
        ].forEach(function (slot) {
            var part = partBy(data, slot.categoryId);
            if (!part) return;
            var component = pickupComponentRecord(meta, part.part_name, slot.position);
            elecRows.push(nameRow(slot.pickup, part.part_name));
            elecRows.push(row(slot.specs, pickupDetail(component.record, part.part_name)));
            elecRows.push(row(slot.voicing, pickupCharacter(component.record)));
        });
        var fxSlots = FX_SLOTS.map(function (slot) {
            var part = partBy(data, slot.categoryId);
            return part ? { id: slot.id, categoryId: slot.categoryId, label: slot.label, modelId: Number(part.model_id), modelName: part.part_name } : null;
        }).filter(Boolean);
        if (fxSlots.length) {
            var packs = (data.availablePacks || []).filter(function (pack) { return pack.pack_type === 'fx_card'; });
            var packName = matchPackName(packs, data.availablePackItems || [], data.availableSwaps || [], fxSlots);
            elecRows.push(row(N_('FX Pack'), joinDot([fxPackHeading(packName), fxPackStory(data.availablePacks, packName)])));
            fxSlots.forEach(function (slot) {
                var card = fxCardInfo(meta, slot.modelName);
                elecRows.push(row(slot.label, joinDot([card.code !== '—' ? card.code : '', card.name, card.description])));
            });
        } else if (x.electronics.part && !x.electronics.isSupreme) {
            elecRows.push(row(N_('FX Cards'), PRIME_FX_NOTE));
        }
        sections.push(section('electronics', EARS.electronics.title, elecRows));

        var binding = normalizeBinding(x.neck.binding);
        var coverName = function (value) { return value ? pickupCoverFinish(meta, value, '').name : ''; };
        var hw = [];
        if (x.bridge) {
            hw.push(row(N_('Bridge Base Plate'), x.bridge.main));
            hw.push(row(N_('Bridge Saddle Block'), x.bridge.secondary));
            hw.push(row(N_('Bridge Rollers'), x.bridge.rollers));
            hw.push(row(N_('Bridge Tuners & Arm Caps'), x.bridge.knobsArmCap));
            hw.push(row(L.tremoloArm, x.bridge.arm));
        }
        if (x.nut) {
            hw.push(row(N_('Shark Nut Base Plate'), x.nut.main));
            hw.push(row(N_('Shark Nut String Carrier'), x.nut.secondary));
        }
        hw.push(row(L.pickupFrames, x.body.frame));
        hw.push(row(L.bridgePickupCover, coverName(x.covers.bridge)));
        hw.push(row(L.neckPickupCover, coverName(x.covers.neck)));
        hw.push(row(L.controlKnobs, x.electronics.knobs));
        hw.push(row(L.switches, x.electronics.switches));
        hw.push(row(L.buttons, x.electronics.buttons));
        hw.push(row(N_('Inlays'), x.neck.inlayDesign && x.neck.inlayMaterial ? joinDot([x.neck.inlayDesign, x.neck.inlayMaterial]) : ''));
        hw.push(row(N_('Shark Logo'), x.neck.logo));
        hw.push(row(L.binding, binding.type === 'none' ? '' : binding.material));
        hw.push(row(L.sideDots, x.neck.sideDots));
        sections.push(section('hardware', EARS.hardware.title, hw));

        sections = sections.filter(Boolean);
        return sections.length ? { kind: kind || 'guitar', sections: sections } : null;
    }

    function pickupFacts(product, meta) {
        meta = meta || {};
        if (!product) return null;
        var position = Number(product.category_id) === 16 ? N_('Neck') : N_('Bridge');
        var component = pickupComponentRecord(meta, product.product_name, position);
        if (!component.record) return null;
        var record = component.record;
        var spec = pickupSpecValues(record);
        var built = section('pickup', N_('Pickup Details'), [
            row(N_('Position'), position + ' pickup'),
            row(N_('Series'), record.series ? String(record.series) + ' series' : ''),
            row(N_('Output'), pickupOutputDisplay(String(record.outputClass || '').replace(/\s*Output\s*/i, '').trim())),
            row(N_('Magnet'), spec.magnetLabel),
            row(spec.electricalLabel, spec.electricalValue),
            row(N_('Resonant Peak'), spec.peakValue),
            row(N_('Voicing'), spec.voicing),
            row(N_('Recommended For'), spec.recommendedFor)
        ]);
        return built ? { kind: 'pickup', sections: [built] } : null;
    }

    return {
        L: L, EARS: EARS, PICKUP_CATS: PICKUP_CATS,
        esc: esc, normKey: normKey, partBy: partBy, propRows: propRows, prop: prop, extract: extract,
        mmNum: mmNum, inNum: inNum, dimensionPair: dimensionPair, shapeLetter: shapeLetter,
        endpointPresentation: endpointPresentation, arrowPair: arrowPair, capWord: capWord,
        customerWoodName: customerWoodName, isNaturalFinishValue: isNaturalFinishValue, visibleFinish: visibleFinish,
        finishPresentation: finishPresentation, bodyPresentation: bodyPresentation, bodyIdentity: bodyIdentity,
        normalizeBinding: normalizeBinding, pickupCoverFinish: pickupCoverFinish,
        pickupOutputDisplay: pickupOutputDisplay, pickupSpecValues: pickupSpecValues,
        pickupComponentRecord: pickupComponentRecord, fxCodeOf: fxCodeOf, fxCardInfo: fxCardInfo,
        fxPackHeading: fxPackHeading, fxPackStory: fxPackStory, architectureName: architectureName,
        profileMetaFor: profileMetaFor, fretsDisplay: fretsDisplay, scaleDisplay: scaleDisplay, neckGeometry: neckGeometry,
        matchPack: matchPack, matchPackName: matchPackName, weightDisplay: weightDisplay,
        specFacts: specFacts, pickupFacts: pickupFacts
    };
});
